// Packages
import { styled } from '@mui/material/styles';
import { TextField } from '@mui/material';

export const StyledInput = styled(TextField, {
  shouldForwardProp: (prop) => prop !== 'isInvalid',
})(({ theme, isInvalid }) => ({
  width: "310px",
  "& .MuiOutlinedInput-root": {
    borderRadius: theme.shape.customBorderRadius[1],
    height: "31px",
    backgroundColor: theme.palette.primary.transparent,

    "& .MuiOutlinedInput-notchedOutline": {
      border: isInvalid ?
        `1px solid ${theme.palette.primary.redPrimary}` :
        `1px solid ${theme.palette.primary.borderGreyPrimary}`
    },

    "&:hover .MuiOutlinedInput-notchedOutline": {
      border: isInvalid ?
        `1px solid ${theme.palette.primary.redPrimary}` :
        `1px solid ${theme.palette.primary.mainHover}`
    },

    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: isInvalid ?
        `1px solid ${theme.palette.primary.redPrimary}` :
        `1px solid ${theme.palette.primary.main}`
    },
  },
}));